<template>
    <div>
        <eco-header :step_num="3" />
        <b-row>
            <b-col>

            </b-col>
        </b-row>
        <b-row v-if="showCompany">
            <b-col>
                <b-spinner v-if='spinner' small label="Loading..."></b-spinner>
                <eco-company-view
                    :company.sync="company" 
                    :items="items" 
                    :editable="true" 
                    :allowNextStep.sync="allowNext"
                    @updateStore="updateStore"/>
            </b-col>
        </b-row>
        <eco-footer :step_num="3" :allow_next="allowNext" />
    </div>
</template>

<script>
export default {
    data() {
        return {
            allowNext: false,
            spinner: false,
            company: null,
            items: [
                '10*address.value',  
                '5*contacts.phone',
                '8*contacts.email',
                'contacts.website', 
                'edo.use',
                'edo.name', 
            ]
        }
    },
    mounted() {
        this.company = this.$store.getters.COMPANY
    },
    methods: {
        updateStore() {
            this.$store.dispatch('COMPANY', this.company)
        }
    },
    computed: {
        showCompany() {
            return true
        }
    }
}
</script>